import { PayloadAction } from '@reduxjs/toolkit';

import { createHcReduxSlice } from '@hcs/utils';

const initialState: HelpChatSliceState = {
  launcherHideId: null,
};
const name = 'helpChat';

export type HelpChatSliceState = {
  launcherHideId: string | null;
};

export type HelpChatPartialAppState = {
  [name]: HelpChatSliceState;
};

export const helpChatSlice = createHcReduxSlice({
  name,
  initialState,
  reducers: {
    hideLauncher: (
      state,
      action: PayloadAction<{ launcherHideId: string }>,
    ) => {
      if (state.launcherHideId === null) {
        state.launcherHideId = action.payload.launcherHideId;
      }
    },
    showLauncher: (
      state,
      action: PayloadAction<{ launcherHideId: string }>,
    ) => {
      if (state.launcherHideId === action.payload.launcherHideId) {
        state.launcherHideId = null;
      }
    },
  },
});
